import random from '../utils/random.js'
import md5Libs from '../utils/md5.js'

import sortingArray from '../utils/sortingArray.js'
export default {
  /**
   * @description 接口签名验证
   * @param {string} t 时间戳
   * @param {string} n 签名字符串
   */
  secretdate: function (params, t = null, n = null) {
    var timestamp = t || Math.round(new Date() / 1000)
    var nonce = n || random.random_char(32)
    const signString =
      "icpEs5TySBpeXoeHbsFK" + '|' + sortingArray.objKeySort(params) + '|' + timestamp + '|' + nonce
    var data_for_sign = md5Libs.md5(signString)
    return {
      'E-APP-TIMESTAMP': timestamp,
      'E-APP-NONCE': nonce,
      'E-APP-SIGN': data_for_sign,
    }
  },
}



// WEBPACK FOOTER //
// ./src/utils/dokey.js